import React from "react";

// Stylesheet
import "./HomeScreen.css";

// Sections
import Welcome from "./sections/welcome/Welcome";
import Use from "./sections/use/Use";
import LatestNFTs from "./sections/latestNFTs/LatestNFTs";
import FAQ from "./sections/FAQ/FAQ";
// import RegisterPopup from "./sections/registerPopup/RegisterPopup";

function HomeScreen() {
  return (
    <div>
      <Welcome />
      <LatestNFTs />
      <Use />
      <FAQ/>
    </div>
  );
}

export default HomeScreen;
